/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { HospitalMultiples } from 'components/HospitalMultiples'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

const params = new URL(window.location.toString()).searchParams
const showLink = !(params.get('link') === 'no')
const showCantons = !(params.get('cantons') === 'no')
const showHeader = !(params.get('header') === 'no')
const lang = ['24heures', 'tdg'].includes(parseHostname().publicationName)
  ? 'fr'
  : 'de'

export function AppComponent() {
  return (
    <div className='index'>
      <ThemeSwitch />
      <HospitalMultiples
        locale={lang}
        showLink={lang === 'de' ? showLink : false}
        showCantons={showCantons}
        showHeader={showHeader}
      />
    </div>
  )
}
